import { Injectable } from '@angular/core';
import { BaseComponentModel } from 'src/app/common/component-model/base-component-model';
import { ComponentModelDependencies } from 'src/app/common/component-model/component-model-dependencies';
import { ComponentModelInfo } from 'src/app/common/component-model/component-model-info';
import { AttachmentDB } from 'src/app/common/repository/databases';
import { SQLiteQueryBuilder } from 'src/app/common/storage/sqlite-query-builder';
import { AttachmentDto } from 'src/app/shared/models/attachment/attachment-dto.model';
import { AttachmentModelName } from 'src/app/shared/models/model-names';

@Injectable({ providedIn: 'root' })
export class AttachmentComponentModel extends BaseComponentModel<AttachmentDto> {
  constructor(componentModelDependencies: ComponentModelDependencies, componentModelInfo: ComponentModelInfo) {
    super(AttachmentModelName, componentModelDependencies, componentModelInfo);
  }

  public async findByUniqueIds(uniqueIds: string[]): Promise<AttachmentDto[]> {
    const wantedAttachments = Array.from(new Set(uniqueIds.filter(uniqueId => Boolean(uniqueId))));
    if (!wantedAttachments.length) {
      return [];
    }
    // FTS stores every value lowercased
    const sql = new SQLiteQueryBuilder().select('id as _id').fromFts(AttachmentDB);
    wantedAttachments.forEach((uniqueId, index) => {
      if (index === 0) {
        sql.where('uniqueId', '=', uniqueId.toLocaleLowerCase());
      } else {
        sql.or('uniqueId', '=', uniqueId.toLocaleLowerCase());
      }
    });
    const rows: Array<{ _id?: string; id?: string }> = await this.componentModelDepencies.queryService.raw<any>(
      {
        sql: sql.asString(),
        aggregation: [{ $match: { 'metadata.uniqueId': { $in: wantedAttachments } } }, { $project: { _id: 1 } }],
      },
      AttachmentDB
    );
    const ids = (rows ?? []).map(row => row?._id ?? row?.id).filter((id): id is string => Boolean(id));
    return ids.length ? this.componentModelDepencies.queryService.getByIds<AttachmentDto>(ids, AttachmentDB) : [];
  }
}
